<template>
  <div>
    <div class="personalForm">
      <div class="form">
        <el-form
          :model="formLabelAlign"
          label-width="120px"
          size="small"
          style="overflow: hidden"
          ref="formLabelAlign"
          :rules="rules"
        >
          <div class="codeIcon">基本信息</div>
          <div class="elFormBox">
            <el-form-item label="用户名">
              <el-input
                v-model="formLabelAlign.account"
                style="width: 300px"
                placeholder="请输入用户名"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="客户名称" prop="userName">
              <el-input
                v-model="formLabelAlign.userName"
                style="width: 300px"
                placeholder="请输入客户名称"
              ></el-input>
            </el-form-item>
          </div>
          <div class="elFormBox">
            <el-form-item label="注册手机">
              <el-input
                v-model="formLabelAlign.mobilePhone"
                style="width: 300px"
                placeholder="请输入注册手机号"
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="linkUserPhone">
              <el-input
                v-model="formLabelAlign.linkUserPhone"
                style="width: 300px"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </div>
          <div class="elFormBox">
            <el-form-item label="身份证号码" prop="idCard">
              <el-input
                v-model="formLabelAlign.idCard"
                style="width: 300px"
                placeholder="请输入身份证号码"
              ></el-input>
            </el-form-item>
            <el-form-item label="个人所在地" prop="city">
              <!-- <el-input
                v-model="formLabelAlign.city"
                style="width: 300px"
                placeholder="请选择个人所在地"
              ></el-input> -->
              <el-cascader
                :options="options"
                @change="locationChange"
                v-model="formLabelAlign.city"
                style="width: 300px"
              ></el-cascader>
            </el-form-item>
          </div>
          <div class="idCars">
            <div style="display:flex;margin-left: 23px;">
              <div class="idCarsIcon">*</div>
              <el-form-item label="身份证照片" label-width="90px"></el-form-item>
            </div>
            
            <div style="position: relative">
              <el-upload
                v-if="!carImg"
                class="upload-demo"
                action="/hxkj_management_server_api/com/file/fileUpload"
                :on-change="handleChange"
                :file-list="fileList"
                :on-success="successImg"
                :show-file-list="false"
              >
                <div class="uploadCar">
                  <div><i class="el-icon-plus"></i></div>
                  <div class="ftcB4 fs14" style="padding: 4px 0">
                    请上传身份证人像面照片
                  </div>
                </div>
              </el-upload>
              <div class="avatar-box" v-if="carImg">
                <img :src="carImg" alt="" />
                <i class="el-icon-close clearVideo" @click="clearVideo"></i>
              </div>
            </div>
          </div>
          <div class="codeIcon">收款信息</div>
          <div class="elFormBox">
            <el-form-item label="收款人姓名">
              <el-input
                disabled
                v-model="formLabelAlign.bankAccountName"
                style="width: 300px"
                placeholder="请输入收款信息"
              ></el-input>
            </el-form-item>
            <el-form-item label="开户行" prop="depositBank">
              <el-input
                v-model="formLabelAlign.depositBank"
                style="width: 300px"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </div>
          <div class="elFormBox">
            <el-form-item label="银行卡号" prop="bankAccount">
              <el-input
                v-model="formLabelAlign.bankAccount"
                style="width: 300px"
                placeholder="请输入银行卡号"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="btnBoxs">
          <!-- <el-button size="small">返回</el-button> -->
          <el-button size="small" class="successBtn" @click="submit">提交</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { register, reSubmitUserInformation } from "@/api/reg/index";
import regular from "@/util/regular";
import china from "@/util/china.json";
import { imageEcho } from "@/api/index";
export default {
  props: {
    personalObj: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    var validateIdcard = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.idCard(value),
        "身份证未填写或格式错误"
      );
    var validatelinkUserPhone = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.testPhone(value),
        "手机号码未填写或格式错误"
      );
    var validatebankAccount = (rule, value, callback) =>
      regular.FormValidateIsTrue(
        rule,
        value,
        callback,
        regular.bankCard(value),
        "银行卡号码未填写或格式错误"
      );
    return {
      formLabelAlign: {
        imageUrl: "",
        type: 0,
        account: "",
        userName: "",
        mobilePhone: "",
        linkUserPhone: "",
        idCard: "",
        city: "",
        depositBank: "",
        bankAccount: "",
        bankAccountName: "",
      },
      fileList: [],
      carImg: "",
      china, //选择详细地址
      options: [],
      rules: {
        userName: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "blur",
          },
        ],
        city: [
          {
            required: true,
            message: "请输入地址",
            trigger: "blur",
          },
        ],
        depositBank: [
          {
            required: true,
            message: "请输入开户行",
            trigger: "blur",
          },
        ],
        idCard: [
          {
            required: true,
            validator: validateIdcard,
            trigger: "blur",
          },
        ],
        linkUserPhone: [
          {
            required: true,
            validator: validatelinkUserPhone,
            trigger: "blur",
          },
        ],
        bankAccount: [
          {
            required: true,
            validator: validatebankAccount,
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    if (this.$route.query.str) {
      let obj = JSON.parse(this.$route.query.str);
      this.formLabelAlign.mobilePhone = obj.mobilePhone;
      this.formLabelAlign.account = obj.account;
    }
    this.citysData(this.china.children);
    /* 是否是重新提交 */
    if (this.$route.query.id == 1) {
      this.formLabelAlign = JSON.parse(JSON.stringify(this.personalObj));
      /* 地址回显 */
      let arr = this.formLabelAlign.city.split(",");
      this.$set(this.formLabelAlign, "city", arr);
      this.$delete(this.formLabelAlign, "createTime");
      this.$delete(this.formLabelAlign, "updateTime");
      /* 图片回显 */
      this.fileUploadapi(this.formLabelAlign.imageUrl);
    }
  },
  watch: {
    "formLabelAlign.userName"(newval) {
      this.formLabelAlign.bankAccountName = newval;
    },
    personalObj: {
      handler(newVal) {
        console.log(newVal, 7777);
        /* 判断是否是重新提交 */
        // if (this.$route.query.id == 1) {
        //     this.formLabelAlign = JSON.parse(JSON.stringify(newVal));
        //     /* 地址回显 */
        //     let arr = this.formLabelAlign.city.split(",");
        //     this.$set(this.formLabelAlign, "city", arr);
        //     this.$delete(this.formLabelAlign, "createTime");
        //     this.$delete(this.formLabelAlign, "updateTime");
        //     /* 图片回显 */
        //     this.fileUploadapi(this.formLabelAlign.imageUrl);
        // }
      },
      deep: true,
    },
  },
  methods: {
    citysData(val) {
      val.map((res) => {
        res.value = res.label;
        if (res.children) {
          this.citysData(res.children);
        }
      });
      this.options = this.china.children;
    },
    locationChange(val) {
      this.formLabelAlign.city = val.join();
    },
    handleChange() {},
    /* 回填图片回显 */
    fileUploadapi(imgPath) {
      imageEcho({
        imgPath,
      }).then((res) => {
        this.carImg = res.data.data.imageCode;
      });
    },
    /* 图片上传成功 */
    successImg(res, file) {
      if(res.code==1) {
        this.formLabelAlign.imageUrl = res.data[0].filePath;
        this.carImg = this.fileUploadapi(res.data[0].filePath)
      } else {
        this.$message.error(res.msg)
      }
      
    },
    /* 删除图片 */
    clearVideo() {
      this.carImg = "";
    },
    /* 新注册 */
    registerapi(data) {
      register(data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: res.data.data,
            type: "success",
          });
          this.$router.push({
            path: "/home",
          });
        }
      });
    },
    /* 重新提交 */
    reSubmitUserInformationapi(data) {
      reSubmitUserInformation(data).then((res) => {
        if (res.data.code == 1) {
          this.$message({
            message: res.data.data,
            type: "success",
          });
          this.$router.push({
            path: "/login",
          });
        }
      });
    },
    /* 提交 */
    submit() {
      
      this.$refs.formLabelAlign.validate((volid) => {
        if (volid) {
          if(this.formLabelAlign.imageUrl=="") {
            return this.$message.warning("请上传身份证照片")
          }
          if (Array.isArray(this.formLabelAlign.city)) {
            this.formLabelAlign.city = this.formLabelAlign.city.join(",");
          }
          if (this.$route.query.id == 1) {
            console.log(this.formLabelAlign)
            this.reSubmitUserInformationapi(this.formLabelAlign);
          } else {
            this.registerapi(this.formLabelAlign);
          }
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.codeIcon {
  position: relative;
  padding: 0 10px 0 35px;
  width: 100%;
  margin: 0 0 16px;
}

.codeIcon::before {
  content: "";
  left: 3px;
  top: 3px;
  padding: 0px 2px;
  margin: 0 6px 0 0;
  background: #14d393;
  border-radius: 0 5px 5px 0;
}

.elFormBox {
  display: flex;
  justify-content: space-between;
}

.personalForm {
  width: 870px;
  margin: 0 auto;
}

.uploadCar {
  border-radius: 5px;
  border: 1px dashed #e5e5e5;
  width: 200px;
  height: 120px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.el-icon-plus {
  font-size: 40px;
  font-weight: bold;
  color: #e6e6e6;
}

.idCars {
  display: flex;
  padding-bottom: 40px;
}

.btnBoxs {
  display: flex;
  justify-content: center;
  padding: 20px 0;

  /deep/.el-button {
    width: 110px;
  }

  .successBtn {
    color: #fff;
    background: #14d393;
    border: 1px solid #14d393;
  }
}

.avatar-box {
  position: absolute;

  top: 0;
  position: relative;

  img {
    width: 200px;
    height: 120px;
    display: block;
  }
}

.clearVideo {
  position: absolute;
  color: red;
  top: 3px;
  right: 2px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}
.idCarsIcon {
  color: #F56C6C;
  padding-top:7px;
}
</style>



// WEBPACK FOOTER //
// src/views/reg/common/personal.vue